// extracted by mini-css-extract-plugin
export default {"totalCount":"totalCountField_totalCount__2WBAd","totalCount__label":"totalCountField_totalCount__label__XbSAj","totalCount__input":"totalCountField_totalCount__input__cON49"};